import { resources } from "@constants/hardcoded-strings";
import {
    AXNUIContent,
    AXNUILayout,
    AXNUITheme
} from "@iddataweb/idw-common-ui/types";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { ThemingFooterValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";

export const getThemingFooterValidationErrors = (
    isUsingThemedUI: boolean,
    axnuiContent: AXNUIContent,
    axnuiLayout: AXNUILayout,
    axnuiTheme: AXNUITheme
): ThemingFooterValidationErrors => {
    let count = 0;
    let customCssError = null;
    let customHtmlError = null;
    if (isUsingThemedUI && axnuiLayout.isFooterEnabled && axnuiTheme.footer?.useHtmlCss) {
        if (!axnuiContent.footer.customCssFooter) {
            count += 1;
            customCssError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (!axnuiContent.footer.customHtmlFooter) {
            count += 1;
            customHtmlError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
    }

    return {
        customCssError,
        customHtmlError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.theming.subTabs.footer.tabName}
            errorCount={count}
        />
    };
};